import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "./theme.css";
import "./media.css";
import { LoaderContext } from "./Helpers/Context/Context";
import Loader from "./Helpers/Loader/Loader";
import Router from "./Routes/Routes";
import Login from "./Pages/Login/Login";
import NewMenu from "./Layout/Menubar/NewMenu";
import { Route, Routes, useLocation } from "react-router-dom";
import LoginPage from "./Pages/Login/Login";
import ForgetPassword from "./Pages/Login/ForgetPassword";
import ResetPasword from "./Pages/Login/ResetPasword";
import { useIsAuthenticated } from "@azure/msal-react";

function App() {
  const [loader, setLoader] = useState<boolean>(false);
  const showLoader = () => setLoader(true);
  const hideLoader = () => setLoader(false);
  const location = useLocation();

  const isAuthenticated = useIsAuthenticated();
 // console.log(isAuthenticated,'flag')


  return (
    <>

      <LoaderContext.Provider value={{ showLoader, hideLoader }}>
        <Router />
         {/* <NewMenu/> Prashant new menu 22-01-2025 */}
         {/* {isAuthenticated ? (
            <NewMenu/>
        ):
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/forgetPassword" element={<ForgetPassword />} />
          <Route path="/resetPassword/:id" element={<ResetPasword />} />
        </Routes>
        } */}
        <ToastContainer
          position="top-center"
          autoClose={false}
          hideProgressBar={true}
          newestOnTop
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          icon={true}
          pauseOnHover
        />
        {loader && <Loader />}
      </LoaderContext.Provider>    
 
    </>
  );
}

export default App;
